export const stringLimiter = (string: string, limit: number = 100) => (string.length > limit ? string.substring(0, limit) + " ..." : string);
